<style scoped>
.multiIndicesMenu{
  display: inline-block;
  float: right;
  font-size: 14px;
}
.zone {
  background: #fff;
}

.zone + .zone {
  margin-top: 20px;
}

</style>
<template lang="pug">
.report 
  PageTitle(
    pagetitle="推广概览",
    tip="推广概览为您分产品线展示推广及效果数据，让您直观得看到各产品线的表现情况，进而优化各产品线推广策略。")
    span.floatr(v-if="dianjingIDList.length > 0")
      label 账号切换：
      v-select(
        v-model="dianjingID",
        :options="dianjingIDList",
        @input="getTableData()"
        )
      
  div.time
    TimeSpan(filters="7a" @change="onTimespanChange")
  .zone
    TableTitle(icon="fa fa-signal" title="趋势图")
      div.multiIndicesMenu
        v-select(
          v-model="customIndice",
          :options="indicesMenu",
          @input="indiceChange")
        

    LineChart(
      :yAxis="yAxis",
      :legend="legend",
      :xAxis="chartXAxis",
      :series="chartSeries")

  .zone
    TableTitle(icon="fa fa-list" title="推广概览报表")
      i.mv-tips(v-show="mvDemain") 为什么看不到流量及转化数据
        v-tooltip(
          :tip="'由于您网站添加的代码为聚合分析代码，无法获取搜索推广对应的流量数据，若您想查看该部分数据，建议为您的网站重新添加360分析代码。'",
          pos="right")
          i.fa.fa-question-circle
      CustomIndice(
        :defaults="defaultCustomIndices",
        :hasSystemIndice="true",
        :hasSpreadIndice="true",
        :fluxExtend= "fluxExtend",
        @change="onCustomIndiceChange")

    complex-table(
      :columns="columns",
      :list="list",
      :sum="{}")
    v-pagination(
      :total="total",
      :pn="pg",
      :ps="ps",
      v-if="total > ps",
      @updatepage="getTableData")

</template>

<script>
  /* global _ */
  import Store from '../../store/store.js'
  import Table from '../../component/complex-table.vue'
  import Mixin from '../mixin.js'
  import Tool from '../../script/tool.js'
  import { INDICE_DEFAULT } from './constants'
  export default {
    store: Store,
    components: {
      'complex-table': Table
    },
    mixins: [Mixin],
    data () {
      return {
        chartResList: [],
        hasCheckBox: false,
        total: 0,
        pg: 1,
        ps: 10,
        isasc: 0,
        order: '',
        legend: [],
        yAxis: [],
        chartXAxis: [],
        chartSeries: [],
        customIndice: 'adpv',
        dianjingID: 0,
        dianjingIDList: [],
        list: {},
        mvDemain: false,
        tableDataList: [],
        fluxExtend: {'reachrate': '到达率'},
        defaultCustomIndices: ['adpv', 'adclick', 'adctr', 'adcost', 'adcpc', 'adcpm', 'pv', 'vnum', 'reachrate', 'atime', 'tnum'],
        tableIndices: ['adpv', 'adclick', 'adctr', 'adcost', 'adcpc', 'adcpm', 'pv', 'vnum', 'reachrate', 'atime', 'tnum']
      }
    },
    computed: {
      domainId () {
        return this.$store.state.domainId
      },
      uiError () {
        return this.$store.state.uiError
      },
      start () {
        return this.$store.state.tableCheckList.length === 0 || !this.$store.state.drawChartabled
      },
      end () {
        return this.$store.state.end.replace(/-/g, '/')
      },
      query () {
        let params = {
          cycle: 'day',
          domainId: this.domainId,
          start: this.$store.state.start,
          end: this.$store.state.end,
          pvtype: 0,
          timespan: new Date().getTime(),
          djid: this.dianjingID
        }
        if (this.order !== '') {
          params = _.assignIn({
            isasc: this.isasc,
            order: this.order
          }, params)
        } else {
          this.$delete(params, 'isasc')
          this.$delete(params, 'order')
        }

        return params
      },
      indicesMenu () {
        const indices = []
        _.map(this.tableIndices, (item) => {
          indices.push({value: item, label: Tool.getIndexName(item)})
        })
        return indices.length > 1 ? indices : INDICE_DEFAULT.map(arr => ({value: arr[0], label: arr[1]}))
      },
      columns () {
        const columns = [
          {
            title: '分析维度',
            fixed: true,
            children: [
              {
                title: '推广趋势',
                key: 'name',
                width: 300,
                render: (index, value, item) => {
                  return this.textEllipsidRender(index, value, item, 15)
                }
              }
            ]
          }
        ]
        const customColumns = this.getCustomColumns({hasSpread: true})

        const newColumns = this.getRecombineColumns(customColumns, this.tableIndices)
        return _.concat(columns, newColumns)
      }

    },
    mounted () {
      this.getSiteDianjingIDs()
      this.checkDomainType()
      this.getTableData()
    },
    watch: {
      domainId () {
        this.getSiteDianjingIDs()
        this.getTableData()
        this.checkDomainType()
      },
      indicesMenu (newVal) {
        const isSameIndice = (a, b) => a === b.value
        let base = _.find(newVal, i => isSameIndice(this.customIndice, i))
        let comp = _.find(newVal, i => isSameIndice(this.twoIndice, i))

        if (base) {
          if (!comp) {
            comp = newVal[0]
          }
        } else {
          base = newVal[1]
          comp = newVal[0]
        }
        this.customIndice = base.value
        this.twoIndice = comp.value
      },
      uiError () {
        this.$Modal.warn(this.uiError.errMsg)
      }
    },
    methods: {
      onCustomIndiceChange (indices) {
        this.tableIndices = indices
      },
      onTimespanChange ({start, end}) {
        this.compareStart = start
        this.compareEnd = end
        if ((new Date(end) - new Date(start)) > 365 * 24 * 3600 * 1000) {
          return this.$Modal.warn(`您选择时间段超过了一年`)
        }
        this.getTableData()
      },
      processMultiDimData (lineDatas, selectedIndice) {
        const dataName = Tool.getIndexName(selectedIndice)
        let legendNames = _.uniq(_.map(lineDatas, 'name'))
        legendNames = _.map(legendNames, name => `${name} - ${dataName}`)
        let seperareLineDatas = _.values(_.groupBy(lineDatas, 'key')) // 每一维度的数据是一个数组
        let xAxis = [] // 根据时间信息生成 x 轴的数据
        const series = [] // 折线图中要用的系列数据

        // 将数据按照时间补齐，没有数据的地方给 0
        seperareLineDatas = _.map(seperareLineDatas, linedata => {
          return this.fieldLoseData({start: this.$store.state.start, end: this.$store.state.end}, linedata)
        })

        xAxis = _.map(seperareLineDatas[0], item => {
          return item.date.split(' ')[0]
        })
        // 由 lineDatas 生成 seriesDatas
        _.forEach(seperareLineDatas, (lineData, i) => {
          const seriesData = _.map(lineData, selectedIndice)

          series.push({name: legendNames[i], data: seriesData})
        })

        return [legendNames, xAxis, series]
      },
      indiceChange () {
        if (_.isEmpty(this.list)) {
          // 清空画图数据
          this.legend = []
          this.chartXAxis = []
          this.chartSeries = []
          return
        }
        if (this.chartResList) {
          const [legendNames, xAxis, series] = this.processMultiDimData(this.chartResList, this.customIndice)
          const yAxis = []
          yAxis.push(this.putyAxisItem(this.customIndice))
          this.yAxis = yAxis
          this.legend = legendNames
          this.chartXAxis = xAxis
          this.chartSeries = series
        }
      },
      getTableData (pn = 1) {
        this.pg = pn
        if (!this.domainId) return
        this.total = 0
        this.$store.dispatch('SET_TABLE_LOADING', true)
        this.$store.dispatch('SET_TABLE_CHECKLIST', [])
        const reportQuery = _.assignIn({
          pg: this.pg,
          ps: this.ps
        }, this.query)
        const chartQuery = _.assignIn({
          ps: 999
        }, this.query)
        const reportPromise = this.$http.get('/api/report/SummaryProduct?groupby=product', {params: reportQuery})
        const lineChartPromise = this.$http.get('/api/report/SummaryProduct?groupby=product,date', {params: chartQuery})
        this.$store.dispatch('VUE_HTTP', [reportPromise, lineChartPromise])
          .then((res) => {
            if (res) {
              this.$store.dispatch('SET_TABLE_LOADING', false)
              const [reportlist, chartlist] = res
              const list = _.map(reportlist.list, (item, index) => {
                this.$set(item, 'index', index + 1)
                return item
              })
              this.list = list
              this.total = reportlist.total
              this.chartResList = chartlist.list
              this.indiceChange()
            }
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// overall.vue?d90cc410